import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollExportDTO  {
    _originalTypeClassName = "zERP.BO.PayrollExportDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollExportDTO.translate = translateService;
}
this.Employees = [];
this.IssuedOn = null;
this.PayableAmount = null;
this.AdvanceAmount = null;
this.Period = null;
this.PayrollExportDTOKey = null;
this._key = this.PayrollExportDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
IssuedOn:any;
PayableAmount:any;
AdvanceAmount:any;
Period:any;
Employees:any;
private _PayrollExportDTOKey:any;
get PayrollExportDTOKey(): any {
    return this._PayrollExportDTOKey;
  }
set PayrollExportDTOKey(value: any) {
    this._PayrollExportDTOKey = value;
    this._key = value;
  }
static setEmployees = ($this, items) => {
                if (items == null) items = [];
                if ($this.Employees == null) $this.Employees = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Employees.length > 0) {
                    Domain.PayrollExportDTO.removeEmployees($this, $this.Employees[0]);
                }

                Domain.PayrollExportDTO.addManyEmployees($this, copyItems);
            }
static addManyEmployees = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollExportDTO.addEmployees($this, items[i]);
                }
            }
static addEmployees = ($this, item) => {
                if ($this.Employees == null) $this.Employees = [];
                if (item == null || $this.Employees.indexOf(item) > -1) return;
                $this.Employees.push(item);
}
static addRangeEmployees = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollExportDTO.addEmployees($this, item));
            }
static removeEmployees = ($this, item) => {
                if ($this == null || $this.Employees == null || $this.Employees.indexOf(item) === -1) return;
                var _index = $this.Employees.indexOf(item);
                $this.Employees.splice(_index, 1);
}
static clearEmployees = ($this) => { $this.Employees = null; }

static Export(payroll: any): any{let exportDTO = new Domain.PayrollExportDTO();
exportDTO.AdvanceAmount = payroll?.AdvanceAmount;
exportDTO.PayableAmount = payroll?.PayableAmount;
exportDTO.IssuedOn = payroll?.IssuedOn;
let ser = new CLMS.Framework.Utilities.Serializer<any>();
return ser.ToJson(exportDTO);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollExportDTOKey == null || $this.PayrollExportDTOKey == 0;
            }


}